export default {
  navigationBarTitleText: '热门问题',
};
